import { getLocalStore, setLocalStore } from '../tool/localStore'
import api from './api'
import { http } from './fetcher'

class Socket {
  client      //socket实例
  userInfo    //会员信息
  serviceInfo //客服信息
  address     //socket地址
  events = {}
  sendId = 4210
  sendMsgEvents = [];
  timer = null;

  connect = async (user) => {
    if (!this.client) {
      this.user = user;
      let dic = getLocalStore("dic");
      if (!dic) {
        const res = await http(api.allDic);
        if (res.code === "C2" && res.result) {
          dic = res.result;
          setLocalStore("dic", res.result)
        }
      }
      if (this.user && dic) {
        const dealerCode = dic.dealerCode;
        this.url = dic['cust.server.socket.url'];
        this.accountNo = this.user.accountNo
        this.address = `${this.url}?dealerCode=${dealerCode}&userId=${this.accountNo}&EIO=3&transport=websocket`
        this.client = new WebSocket(this.address);
        this.initEventHandle();
        this.heartBeat();
      }
    }
  }

  initEventHandle = () => {
    this.client.onmessage = (res) => {
      if (/^\d+\[/.test(res.data)) {
        const id = parseFloat(res.data);
        const arr = JSON.parse(res.data.replace(`${id}`, ''))
        const type = arr[0];
        const data = arr[1];

        if (this.events[type]) {
          for (let i = 0; i < this.events[type].length; i++) {
            const fn = this.events[type][i];
            fn(data)
          }
        }

        for (let i = 0; i < this.sendMsgEvents.length; i++) {
          const item = this.sendMsgEvents[i];
          if (item.sendId + 100 === id) {
            item.cb(type);
            this.sendMsgEvents.splice(i, 1)
            break;
          }
        }
      }
    }

    this.client.onerror = () => {
      this.close();
      this.connect();
    }

    this.client.onclose = () => {
      if (this.client) {
        this.close();
        this.connect();
      }
    }
  }

  setServiceInfo = (serviceInfo) => {
    this.serviceInfo = serviceInfo
  }

  sendMsg = (msg, event, cb) => {
    const newData = `${this.sendId}["${event}",${JSON.stringify(msg)}]`
    this.client.send(newData);
    this.sendMsgEvents.push({ sendId: this.sendId, cb })
    this.sendId++;
  }

  heartBeat = () => {
    clearInterval(this.timer);
    if (this.client) {
      this.timer = setInterval(() => {
        if (this.client) {
          this.client.send("2");
        }
      }, 30000);
    }
  }

  subscribe = (event, cb) => {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(cb)
  }

  unsubscribe = (event, cb) => {
    if (this.events[event]) {
      if (cb) {
        this.events[event] = this.events[event].filter(item => item !== cb)
      } else {
        this.events[event] = null
      }
    }
  }

  close = () => {
    clearInterval(this.timer);
    if (this.client) {
      this.client.close()
      this.client = null;
    }
  }
}

const socket = new Socket();
export default socket